import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import LoginView from './views/LoginView';
import AuthView from './views/AuthView';
import PrivateRoute from './components/Utilities/PrivateRoute';
import ValidationRequestsModuleContainer from './containers/ValidationRequestsModuleContainer';
import { history } from './store';
import OrganizationView from './views/OrganizationView';
import MainView from './views/MainView';
import { OrganizationProvider } from 'contexts/OrganizationsContext';

const ReactRouter = () => {
    return (
        <ConnectedRouter history={history}>
            <OrganizationProvider>
                <Switch>
                    <Route path="/login">
                        <LoginView />
                    </Route>
                    <Route path="/auth/:token">
                        <AuthView />
                    </Route>
                    <PrivateRoute path={`/organization/:orgId/spots/:spotId/validation`}>
                        <ValidationRequestsModuleContainer />
                    </PrivateRoute>
                    <PrivateRoute path="/organization/:orgId">
                        <OrganizationView />
                    </PrivateRoute>
                    <PrivateRoute path="/">
                        <MainView />
                    </PrivateRoute>
                </Switch>
            </OrganizationProvider>
        </ConnectedRouter>
    );
};

export default ReactRouter;
